// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__h53ty","row":"styles_row__W_wMt","half":"styles_half__2gjag","leftHalf":"styles_leftHalf__3oNhP","rightHalf":"styles_rightHalf__3R8H5"};